import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { L10n } from '../../../commonInfra/L10n/L10n';
import { BreadcrumbInfo } from './BreadcrumbInfo';
import { BreadcrumbStyles } from './BreadcrumbStyles';

export function Breadcrumb(props: Breadcrumb.Props): React.ReactElement<Breadcrumb.Props> {
  const { text, href, testId } = props;
  const tooltip = props.tooltip ? props.tooltip : text;
  const displayTitle = L10n.elideIfLong(text, 50);

  const style = href? BreadcrumbStyles.Breadcrumb : BreadcrumbStyles.NonLinkBreadcrumb;

  let breadcrumbElement: JSX.Element;
  if (href) {
    breadcrumbElement = <TextLinkWidget href={href} aria-label={text} testId={null}>{displayTitle}</TextLinkWidget>;
  } else {
    breadcrumbElement = <span aria-label={text} className={BreadcrumbStyles.NonLinkBreadcrumbText}>{displayTitle}</span>;
  }

  return (
    <li className={style} title={tooltip} data-tb-test-id={testId}>
      {breadcrumbElement}
    </li>
  );
}

export namespace Breadcrumb {
  export interface Props extends BreadcrumbInfo {}
}
